import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
import home from "../views/home.vue";
import list from "../views/list.vue";
Vue.use(VueRouter);



const routes = [
    {
        path: "/",
        component: home,
        name: "Home"
    },
    {
        path: "/list",
        component: list,
        name: "List"
    },
]

var router =  new VueRouter({
    routes
})
export default router;